const steps = [
  {num: '01', icon: '✦', title: 'Describe your idea', description: 'Tell Landed what you want to create in plain language.'},
  {num: '02', icon: '◫', title: 'Make it yours', description: 'Refine the design, copy, colors, and details with AI.'},
  {num: '03', icon: '↗', title: 'Publish instantly', description: 'Go live on a Landed URL or connect your own domain.'},
];

export function HowItWorksSection() {
  return (
    <section id="how" className="section how-section shell">
      <div className="steps-container">
        <div className="section-heading centered fade-up">
          <span className="kicker">HOW IT WORKS</span>
          <h2 className="section-title" style={{margin: '15px auto 0', maxWidth: 'none'}}>
            From thought to live
            <br />
            <em>in three simple steps.</em>
          </h2>
        </div>
        <div className="steps-grid">
          {steps.map((step, i) => (
            <article key={step.num} className="step-card fade-up" style={{transitionDelay: `${i * 0.1}s`}}>
              <span className="step-num">{step.num}</span>
              <div className="step-icon">{step.icon}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
